<div class="modal-header">
   <h4 class="modal-title">Add New Payment Method</h4>
   <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
   <div class="row g-3">
      <div class="col-12 col-md-6 pe-md-4 payment-method-modal__method-col">
         <div class="mb-3">
            <div class="btn-group w-100" role="group" aria-label="Payment method type">
               @for (type of supportedPaymentInstrumentTypes; track type) {
                  <button type="button"
                          class="btn"
                          [class.btn-secondary]="paymentInstrumentType() === type"
                          [class.btn-outline-secondary]="paymentInstrumentType() !== type"
                          (click)="selectPaymentInstrumentType(type)">
                     {{ getDescription(type) }}
                  </button>
               }
            </div>
         </div>

         @if (paymentInstrumentType() === PaymentInstrumentType_.PaymentCard) {
            <app-payment-card (formReady)="onMethodFormReady($event)" />
         } @else {
            <app-eft-record (formReady)="onMethodFormReady($event)" />
         }
      </div>

      <div class="col-12 col-md-6 ps-md-4">
         <fieldset>
            <legend> Billing Address</legend>
            <app-billing-address (formReady)="onAddressFormReady($event)" />
         </fieldset>
      </div>
   </div>
</div>
@if (errorMessage()) {
   <div class="alert alert-danger mx-3 mb-0 mt-2 py-2" role="alert">
      <strong>Unable to save the payment method.</strong>
      <div class="small">{{ errorMessage() }}</div>
   </div>
}
<div class="modal-footer">
   <button type="button" class="btn btn-secondary" [disabled]="isSubmitting()" (click)="cancel()">Cancel</button>
   <button type="button" class="btn btn-primary" [disabled]="isSaveDisabled()" (click)="save()">{{ isSubmitting() ? 'Saving…' : 'Save' }}</button>
</div>
